import _ from 'underscore';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { pushpinColors } from './get-bing-map-colors';

const { ZIndexShellComponents } = Constants;

export const getStyles = (component, { palette = {} }) => {
  const legendItemColors = {};
  _.each(pushpinColors, (value, key) => {
    legendItemColors[`&.legend-item-icon-${key}`] = value;
  });

  return {
    bingMapsView: {
      zIndex: ZIndexShellComponents.Content,

      '& .bing-maps-view-default-tooltip': {
        paddingBottom: '24px',

        fontSize: '12px',
        lineHeight: '16px',
        color: '#323130',
        textAlign: 'initial',

        '& .tooltip-container': {
          padding: 15,
          boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          '@supports (backdrop-filter: blur(60px))': {
            backdropFilter: 'blur(60px)',
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
          },

          marginLeft: '-26px',
          width: '200px',
        },

        '& .title': {
          margin: '0 4px 0 0',
          overflow: 'hidden',
          opacity: '0.8',
          marginBottom: '8px',
        },

        '& .legend': {
          '& .legend-item-icon': {
            ...legendItemColors,
            marginRight: '8px',
          },

        },
      },

      '& .bm_LogoContainer a:focus': {
        outline: `1px solid ${palette.neutralSecondary} !important`,
      },
    },
    announceArea: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      border: '0',
    },
  };
};
